import { render, staticRenderFns } from "./ExternalReferences.vue?vue&type=template&id=ad7dad60"
import script from "./ExternalReferences.vue?vue&type=script&lang=js"
export * from "./ExternalReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports